/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

window.Parsley.addValidator('timeRequiresDate', {
  validateString: function(value, requirement) {
    // valid if there's no time inputted
    if (!value) {
      return true;
    }

    var dateValue = document.querySelector(requirement).value;

    // invalid if the date is null or --
    if (!dateValue || dateValue === '--') {
      return false;
    }

    return true;
  },
  messages: {
    en: 'A date is required when a time is entered.'
  }
});
